var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduleAlert = function SvgScheduleAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 24 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5.25v2.5H3.25a2.49 2.49 0 0 0-2.5 2.5v17.5a2.5 2.5 0 0 0 2.5 2.5h17.5c1.387 0 2.5-1.113 2.5-2.5V5.25a2.5 2.5 0 0 0-2.5-2.5H19.5V.25H17v2.5H7V.25zM3.25 9h17.5v13.75H3.25zm7.5 1.25v6.25h2.5v-6.25zm0 8.75v2.5h2.5V19z"
  })));
};
export default SvgScheduleAlert;